import { SHOWLOADER, HIDELOADER, UPDATEMANAGEITEM, LOCATIONAPICALL, NOTIFICATIONAPI, ENABLE_NAVIGATION, ENABLE_NAVIGATION2} from "../actions";

const initialState = {
  loader: false,
  updateManageItem: '',
  locationApiCall: false,
  notificationApi:false,
  isEnableNavigation:true,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOWLOADER:
      return { ...state, loader: true };
    case HIDELOADER:
      return { ...state, loader: false };
    case UPDATEMANAGEITEM:
      return { ...state, updateManageItem: action.payload };
      case LOCATIONAPICALL:
      return { ...state, locationApiCall: action.payload };
      case NOTIFICATIONAPI:
        return { ...state, notificationApi: !state.notificationApi};
      // case ENABLE_NAVIGATION:
      //   return { ...state, isEnableNavigation: action.payload };
    default:
      return { ...state };
  }
};

export default reducer;